export default "__VITE_PUBLIC_ASSET__fa7f29ea__"